import { useCallback, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import { AnalyticalEvent } from '@modules/activity/types'
import { debounce } from '@mui/material'

export interface Pendo {
  track: (eventName: string, event: AnalyticalEvent) => void
}

const DEFAULT_DEBOUNCE_DELAY = 500

export const usePendoTrackEvent = (delay: number = DEFAULT_DEBOUNCE_DELAY) => {
  const location = useLocation()

  const debouncedEventTrackers = useRef(new Map<string, (event: AnalyticalEvent) => void>())

  const trackPendoEvent = useCallback(
    (eventName: string, event: AnalyticalEvent) => {
      try {
        if (!debouncedEventTrackers.current.has(eventName)) {
          const debouncedTracker = debounce((e: AnalyticalEvent) => {
            window.pendo?.track(eventName, e)
          }, delay)
          debouncedEventTrackers.current.set(eventName, debouncedTracker)
        }

        debouncedEventTrackers.current.get(eventName)?.(event)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error tracking Pendo event:', error)
      }
    },
    [delay],
  )

  return { location, trackPendoEvent }
}
